import { render, staticRenderFns } from "./SignupForm.vue?vue&type=template&id=8346d8be&scoped=true"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"
import style0 from "./SignupForm.vue?vue&type=style&index=0&id=8346d8be&prod&lang=scss"
import style1 from "./SignupForm.vue?vue&type=style&index=1&id=8346d8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8346d8be",
  null
  
)

export default component.exports